import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

const VisibilityGuard = props => {
  const [showChildren, setShowChildren] = useState(false);

  useEffect(() => {
    checkVisibility();
  }, [props.user, props.allowedRoles]);

  const checkVisibility = () => {
    if (!props.user) return;
    if (props.allowedRoles && props.allowedRoles.length) {
      setShowChildren(props.allowedRoles.includes(props.user.role));
    } else {
      setShowChildren(true);
    }
  };

  return showChildren ? props.children : props.showEmpty ? <>&nbsp;</> : null;
};

const mapStateToProps = (state, otherProps) => {
  return {
    user: state.authReducer.user,
  };
};
const mapDispatchToProps = dispatch => ({});
export default connect(mapStateToProps, mapDispatchToProps)(VisibilityGuard);
